import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InfoModal from '@exchange/libs/modals/src/lib/common/InfoModal.vue';


const __default__ = {
  name: 'ProhibitedRetailAmlModal',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["contact-support", "logout"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "content-test-id": "prohibited-retail-aml-modal-content",
    variant: "dark",
    "no-icon": true,
    title: "ui.prohibitedRetailAmlModal.title",
    message: _ctx.$t('ui.prohibitedRetailAmlModal.message'),
    action: "ui.prohibitedRetailAmlModal.primaryAction",
    "action-test-id": "contact-support",
    "action-secondary": "modules.auth.logout",
    "action-secondary-test-id": "logout",
    onActionClicked: _cache[0] || (_cache[0] = ($event: any) => (emit('contact-support'))),
    onActionSecondaryClicked: _cache[1] || (_cache[1] = ($event: any) => (emit('logout')))
  }, null, 8, ["message"]))
}
}

})